import { IconButton } from '@mui/material';
import { Dropdown, MenuProps, Space } from 'antd';
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import './style.css'
import { DinneyObject } from '../../model/DinneyObject';
import {isMobile} from "react-device-detect";

export const HeaderSorterColumn : React.FC<{columnName : string, sortCondition : string,
    handleSort : (column : string, descending: boolean, list? : DinneyObject[] | undefined) => void,
}> = (props) => {

    const {columnName, sortCondition, handleSort} = props
    const items: MenuProps['items'] = [
        {
          key: '1',
          label: (
            <>
            <IconButton size='small' onClick={() => handleSort(sortCondition, false)}><ArrowCircleUpIcon/></IconButton>
            <IconButton size='small' onClick={() => handleSort(sortCondition, true)}><ArrowCircleDownIcon/></IconButton>
            </>
          ),
        }
      ];

      return (
        <Dropdown menu={{ items }} arrow placement='topLeft'>
            <Space>
                <span className={isMobile ? 'mobile-text-size' : ''}>{columnName}</span>
            </Space>
        </Dropdown> 
      )
}